import { Entity, makeClone } from 'gossamer-unified';
import { InstitutionGroupEvent } from './InstitutionGroupEvent';
import { Event } from './Event';
import { EVENTS_I_HOST } from './SecurityRules';

export interface InstitutionGroupEventViewRow {
  id: number;
  institution_group_id: number;
  created_at: string;
  event_id: number;
  title: string;
  start_at: string;
  end_at: string;
  visibility_limit: string;
  flow_option: string;
  institution_id: number;
  main_host_user_id: string;
}

const clone = makeClone();

export const InstitutionGroupEventView: Entity<InstitutionGroupEventViewRow> = {
  id: 'InstitutionGroupEventView',
  title: 'Institution Group Event View',
  service: 'main',
  rowLabel: (row: InstitutionGroupEventViewRow) => [row.institution_group_id, row.event_id].join(' / '),
  rowLabelDynamic: (row: InstitutionGroupEventViewRow) =>
    `<lookup:Event:${row.event_id}> / <lookup:InstitutionGroup:${row.institution_group_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.institution_group_event_view',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: 'institution_id = {adminInstitutionId}',
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_group_id', 'ASC']],
  defaultFilters: [],
  fields: {
    id: clone(InstitutionGroupEvent.fields.id),
    institution_group_id: clone(InstitutionGroupEvent.fields.institution_group_id),
    created_at: clone(InstitutionGroupEvent.fields.created_at),
    event_id: clone(InstitutionGroupEvent.fields.institution_event_id),
    title: clone(Event.fields.title),
    start_at: clone(Event.fields.start_at),
    end_at: clone(Event.fields.end_at),
    visibility_limit: clone(Event.fields.visibility_limit),
    flow_option: clone(Event.fields.flow_option),
    institution_id: clone(Event.fields.institution_id),
    main_host_user_id: clone(Event.fields.main_host_user_id),
  },
};
